export const SITE_NAME = 'Remove Background';
export const COMPANY_NAME = 'The Internet Company Group S.L';
export const TAX_ID = 'B21684139';
export const APP_BASE_URL =
	import.meta.env.VITE_BASE_URL || window.location.origin;

export const SUPPORT_EMAIL = 'support@remove-background.com';
export const PHONE = 1112341234;
export const DOMAIN = 'remove-background.com';

export const IMAGE_TTL_HOURS = 24;

export const ACCEPTED_FILE_TYPES = ['image/png', 'image/webp', 'image/jpeg'];

export const SENTRY_ENABLED = !!import.meta.env.VITE_SENTRY_DSN;

export const TAX_PAYER_TYPE = {
	COMPANY: 'company',
	PRIVATE: 'private'
};

export const SOCIAL_LINKS = {
	x: 'https://x.com/RBackground_com',
	facebook: 'https://www.facebook.com/Remove.Background.SL/',
	linkedin: 'https://www.linkedin.com/company/remove-background-com/'
};

export const RTL_LANGUAGES = ['he', 'ar'];

export const TRIAL_DAYS = 7;

export const STORAGE_DAYS = 7;

export const TRIAL_DISCOUNT_DAYS = 7;

export const REVIEW_URL =
	'https://www.trustpilot.com/evaluate/remove-background.com';

export const PAYMENT_HANDLER = 'adyen';

export const invoiceDelayHours = 72;

export const AMEX_SETTLEMENT_DAYS = 10;

export const TRUSTPILOT_RATING_VALUE = 4.2; // TODO: review this value

export const TRUSTPILOT_RATING_COUNT = 8687; // TODO: review this value
